import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
	},
	description: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		lineHeight: 1.5,
		maxWidth: 560,
	},
	numberList: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
	},
	numberRow: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.md,
	},
	statusRow: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
	},
});
